/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EffectiveBrandingOutSource } from './effectiveBrandingOutSource';

/**
 * What `capture/snapshot.py::_branding()` returns right now for the org.
 */
export interface EffectiveBrandingOut {
  bot_name: string;
  source: EffectiveBrandingOutSource;
}
